export default __webpack_public_path__ + "static/media/about.8f7ba6a0.png";